module.exports = {"513401001":"北城街道","513401002":"西城街道","513401003":"东城街道","513401004":"长安街道","513401005":"新村街道","513401007":"海南街道","513401008":"马道街道","513401101":"礼州镇","513401102":"安宁镇","513401103":"川兴镇","513401104":"黄联关镇","513401105":"佑君镇","513401106":"太和镇","513401107":"安哈镇","513401108":"阿七镇","513401109":"樟木箐镇","513401110":"琅环镇","513401111":"巴汝镇","513401203":"四合乡","513401211":"开元乡","513401212":"大兴乡","513401215":"经久乡","513401219":"裕隆回族乡","513401220":"高草回族乡","513401228":"马鞍山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513401.json
// module id = 2561
// module chunks = 0